export default __webpack_public_path__ + "static/media/manifiesto_portrait_pt.84385d9a.mp4";